import React from 'react';

import { bemCssModules } from '@cryptoboyio/mercuryo-lab/utils';

import { Button } from '@components/Button';

import style from '../Transactions.scss';

const cn = bemCssModules(style, 'Transactions');

export type NextButtonType = {
  onClick: () => void;
  isLoading?: boolean;
  title: string;
};

export const NextButton: CustomFC<NextButtonType> = ({ onClick, isLoading, title }) => (
  <div className={cn('more')}>
    <Button isLoading={isLoading} onClick={() => onClick()}>
      {title}
    </Button>
  </div>
);

export default NextButton;
